<template>
  <div class="cv-highlights">
    <h2 class="cv-highlights_title">CV highlights</h2>
    <div
      class="cv-highlights_text collect-editor collect-editor--white"
      v-html="artist.past_shows_and_fair_booths"
    ></div>
    <BaseButton
      v-if="artist.view_more_url"
      class="button button--xs button--white"
      text="VIEW MORE"
      @click="changeLocation(artist.view_more_url)"
    />
  </div>
</template>

<script>
import BaseButton from "@/components/buttons/BaseButton.vue";

export default {
  components: {
    BaseButton,
  },
  props: {
    artist: {
      type: Object,
      required: true,
    },
  },
  methods: {
    changeLocation(url) {
      if (url) window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.cv-highlights {
  display: flex;
  flex-direction: column;
  margin: 15rem 0rem 0rem;
  width: 70%;
  @media screen and (max-width: $md) {
    width: 100%;
  }
  @media screen and (max-width: $xs) {
    margin: 10rem 0rem 0rem;
  }

  &_title {
    font-size: 4rem;
    line-height: 5rem;
    margin-bottom: 5rem;
    @media screen and (max-width: $xs) {
      font-size: 3.5rem;
      line-height: 4.3rem;
    }
  }

  &_text {
    margin-bottom: 3rem;
  }

  .button {
    min-width: 180px;
    @media screen and (max-width: $xs) {
      display: none;
    }
  }
}
</style>

